/* Extracted from sections/header.liquid (lines 3390-3704 of the 20 Oct 2026 live copy) by checks/split_inline_js.py.
   Same code, same position in the page; now a cached asset instead of inline HTML. */
  /* Sticky header — JS position:fixed approach (reliable regardless of overflow/stacking) */
  (function () {
    'use strict';
    var header = document.querySelector('.tc-header--sticky');
    if (!header) return;

    var spacer = document.getElementById('tc-header-spacer');
    if (!spacer) return;

    var isFixed = false;
    var ticking = false;
    var triggerOffset = 0;
    var headerHeight = 0;

    /* Carry the announcement bar along when the header fixes (2026-08-18):
       the bar holds the claim-your-code offer, and scrolling it away meant
       most of a page view never saw it. The bar's own position:sticky can't
       work — its section wrapper is exactly its own height. */
    var bar = document.querySelector('.tc-announcement');
    /* Mobile jank B (26 Oct 2026): while the bar is fixed, its own section
       wrapper keeps the bar's height and the spacer stands in for the header
       only. Before, the wrapper collapsed and the spacer took both heights, so
       the header section jumped 46px up and grew 46px when the chrome pinned
       at load (CLS 0.007 on every page; nothing painted moved). */
    var barSlot = bar ? bar.parentElement : null;

    /* Phone scroll jank (31 Oct 2026): the bar's height is read when the
       chrome is measured, not on every scroll frame. A live offsetHeight read
       straight after the tuck's style writes forced a whole-page style and
       layout pass mid-scroll (42-255 ms on a mid-range phone, right where the
       home hero hands over to the page). */
    var barH = 0;

    function barHeight() {
      if (!bar || bar.classList.contains('is-dismissed')) return 0;
      return barH;
    }

    var root = document.documentElement;

    /* Landscape phones (B7-05): with ~390px of height, a fixed offer bar +
       header + search strip took 40% of the screen. Below 500px tall the
       chrome scrolls away with the page. */
    var shortMq = window.matchMedia ? window.matchMedia('(max-height: 500px)') : null;

    function isLocked() {
      /* TheColor.ScrollLock pins the body (position:fixed) while a dialog is
         open, so pageYOffset reads 0: ignore those scroll/resize events or the
         header would unfix and drop out of view behind the dialog. */
      return root.classList.contains('tc-scroll-locked');
    }

    /* B2-01: pin from the top of the carried offer bar (not the header), so
       header and bar fix together and nothing scrolls away first. While
       fixed, the spacer starts exactly where the bar used to be. (iOS fires
       resize whenever the URL bar shows or hides, so this runs mid-scroll.) */
    function measure() {
      barH = bar ? bar.offsetHeight : 0;
      var lead = barHeight() > 0 ? bar : header;
      triggerOffset = isFixed
        ? (barHeight() > 0 ? barSlot : spacer).getBoundingClientRect().top + window.pageYOffset
        : lead.getBoundingClientRect().top + window.pageYOffset;
      headerHeight = header.offsetHeight;
      publishFixedTop();
    }

    /* --tc-fixed-top: the fixed chrome's height (header + carried bar). Read
       by base.css (scroll-padding-top, so in-page anchors land below the
       header) and theme.js (anchor offsets). 0 when nothing is fixed. */
    /* Design polish round 1, item 2 (owner-approved 22 Oct 2026): on phones
       the carried offer bar slides away while the thumb scrolls DOWN and comes
       back on the first scroll UP, so reading gets its 46 px back. The header
       stays pinned and moves up into the bar's place (its `top` is
       --tc-bar-offset); the spacer keeps the full height, so the page never
       jumps. The bar is never condensed or hidden for good (owner decision
       2026-08-22 stands): any upward movement, or scrolling back near the
       top, brings it back. Desktop and tablet are unchanged. */
    var tuckMq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    var tucked = false;
    var lastY = 0;
    var publishTimer = null;

    function publishFixedTop() {
      var h = (shortMq && shortMq.matches) ? 0 : headerHeight + (tucked ? 0 : barHeight());
      /* After a tuck this waits for the scroll to pause (publishLater), even
         when a toolbar hiding mid-scroll re-measures the chrome. */
      if (!publishTimer) root.style.setProperty('--tc-fixed-top', h + 'px');
      /* --tc-chrome-top (mobile jank, 26 Oct 2026): the same chrome height
         but never minus the tucked bar. The home hero sizes itself to the
         first screen with it, so it no longer grows/shrinks 46px (moving the
         dock, SHOP button and Best sellers) every time the bar tucks or
         returns. Everything else keeps reading --tc-fixed-top. */
      root.style.setProperty('--tc-chrome-top', ((shortMq && shortMq.matches) ? 0 : headerHeight + barHeight()) + 'px');
    }

    function applyFixedState() {
      var bh = isFixed ? barHeight() : 0;
      if (bar) {
        bar.classList.toggle('is-fixed', isFixed && bh > 0);
        bar.classList.toggle('is-tucked', isFixed && bh > 0 && tucked);
        barSlot.style.height = bh > 0 ? bh + 'px' : '';
      }
      /* While the bar is tucked the header's own class lifts it to the top
         (31 Oct 2026), so a tuck no longer changes this page-wide value:
         changing it mid-scroll restyled every element on the page. */
      root.style.setProperty('--tc-bar-offset', bh + 'px');
      header.classList.toggle('is-bar-tucked', isFixed && bh > 0 && tucked);
      spacer.style.height = isFixed ? headerHeight + 'px' : '0';
    }

    /* Phone scroll jank (31 Oct 2026): the header used to follow the bar by
       transitioning `top`, which the browser re-lays out on the main thread
       every frame, so on most phone browsers it stuttered and lagged the bar
       (which slides with a transform). Now the header takes its new `top` at
       once and a transform animation, run by the compositor like the bar's,
       carries it from where it was: the same 0.3 s slide. The transform
       lasts only for the slide, and any tap or key ends it at once, so the
       menu drawer and search overlay (fixed inside the header) are never
       laid out against a moving header. A dismissed bar still snaps header
       and spacer together (B2-01). */
    var slideAnim = null;
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function slideOffset() {
      if (!slideAnim) return 0;
      var m = getComputedStyle(header).transform;
      var v = m && m !== 'none' ? m.slice(m.indexOf('(') + 1, -1).split(',') : null;
      return v ? parseFloat(v[v.length === 16 ? 13 : 5]) || 0 : 0;
    }

    function endSlide() {
      if (slideAnim) { slideAnim.cancel(); slideAnim = null; }
    }

    function slideHeader(from) {
      endSlide();
      if (Math.abs(from) < 1 || !header.animate || (reduceMq && reduceMq.matches)) return;
      slideAnim = header.animate(
        [{ transform: 'translateY(' + from + 'px)' }, { transform: 'translateY(0)' }],
        { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );
      slideAnim.onfinish = function () { slideAnim = null; };
    }

    document.addEventListener('pointerdown', endSlide, { capture: true, passive: true });
    document.addEventListener('keydown', endSlide, true);

    function setTucked(next, slide) {
      if (next === tucked) return;
      var bh = barHeight();
      var ty = slide ? slideOffset() : 0;
      tucked = next;
      applyFixedState();
      if (slide) slideHeader((tucked ? bh : -bh) + ty);
      else endSlide();
      /* --tc-fixed-top (in-page anchors, the pop-up's home trigger) catches
         up once the scroll has paused, for the same reason as above. */
      publishLater();
    }

    function publishLater() {
      clearTimeout(publishTimer);
      publishTimer = setTimeout(function () { publishTimer = null; publishFixedTop(); }, 300);
    }

    /* The search strip stays visible while scrolling (owner decision
       2026-09-29), so the header keeps one height and the spacer always
       matches it exactly. The offset and spacer are set BEFORE the class, so
       `top` never resolves to 0 for a frame. */
    function update() {
      ticking = false;
      if (isLocked()) return;
      var y = window.pageYOffset;
      var shouldFix = !(shortMq && shortMq.matches) && y >= triggerOffset;
      if (shouldFix !== isFixed) {
        isFixed = shouldFix;
        applyFixedState();
        header.classList.toggle('is-fixed', isFixed);
      }
      /* item 2: tuck on a clear downward scroll once the chrome is pinned and
         the top of the page is out of sight; return on any upward scroll. */
      if (tuckMq && tuckMq.matches && isFixed && barHeight() > 0) {
        var dy = y - lastY;
        if (dy > 8 && y > triggerOffset + headerHeight + 120) setTucked(true, true);
        else if (dy < -4 || y <= triggerOffset + 8) setTucked(false, true);
      } else if (tucked) {
        setTucked(false, false);
      }
      lastY = y;
    }

    /* Dismissing the bar: it hides with display:none (no collapse to wait
       out), so reclaim its space on the next frame. */
    if (bar) {
      bar.addEventListener('click', function (e) {
        if (!e.target.closest('.tc-announcement__dismiss')) return;
        requestAnimationFrame(function () {
          if (isFixed) applyFixedState();
          measure();
          update();
        });
      });
    }

    function onScroll() {
      if (publishTimer) publishLater();
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    function remeasure() {
      if (isLocked()) return;
      measure();
      if (isFixed) applyFixedState();
      update();
    }

    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    if (shortMq) {
      if (shortMq.addEventListener) shortMq.addEventListener('change', remeasure);
      else if (shortMq.addListener) shortMq.addListener(remeasure);
    }
    /* Web fonts can change the header's height after the first measure */
    window.addEventListener('load', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    /* A dialog let go of the page: the scroll position is back, re-sync. */
    document.addEventListener('tc:scrolllock', function (e) {
      endSlide();
      if (e.detail && e.detail.locked === false) remeasure();
    });
    /* The bar's height is cached (above): pick up any change to it. */
    if (bar && window.ResizeObserver) {
      new ResizeObserver(function () {
        if (bar.offsetHeight !== barH) remeasure();
      }).observe(bar);
    }
    update();
  })();

  /* Sticky mobile Book Now — show after user scrolls past the hero, hide near footer */
  (function () {
    'use strict';
    var cta = document.querySelector('[data-mobile-book-cta]');
    if (!cta) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    var threshold = 320; // px scrolled before showing
    var ticking = false;
    var visible = false;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      // Hide near the footer so the CTA doesn't overlap newsletter/legal links
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var nearBottom = docHeight > 0 && y > docHeight - 160;
      var shouldShow = y > threshold && !nearBottom;

      if (shouldShow !== visible) {
        visible = shouldShow;
        cta.setAttribute('data-visible', visible ? 'true' : 'false');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  /* Desktop nav disclosures (2026-09-29) — the Shop mega-menu and the small
     Salon dropdown. Disclosure pattern (button + aria-expanded + controlled
     panel), not an ARIA menu, so every link stays a plain link in tab order.
     - mouse: hover-intent — opens 300ms after entering (nav H9: 90ms let a
       cursor crossing the bar towards search or the cart flash the full-width
       panel open), closes 220ms after leaving
     - click / Enter / Space toggles; a click on a hover-opened panel pins it
       open rather than shutting it in the shopper's face
     - keyboard-opened panels stay open until Esc, a click away, or focus
       leaving the item; Esc returns focus to the button
     - ArrowDown on the button opens the panel and focuses its first link
     Only one panel is open at a time. */
  (function () {
    'use strict';
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-tc-disclosure]'));
    if (!items.length) return;
    var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var HOVER_OPEN_MS = 300;

    function btnOf(item) { return item.querySelector('[data-tc-disclosure-trigger]'); }
    function panelOf(item) { return item.querySelector('[data-tc-disclosure-panel]'); }
    function isOpen(item) { return btnOf(item).getAttribute('aria-expanded') === 'true'; }

    function close(item, restoreFocus) {
      clearTimeout(item._tcTimer);
      if (!isOpen(item)) return;
      btnOf(item).setAttribute('aria-expanded', 'false');
      item._tcOpenedBy = null;
      if (restoreFocus) btnOf(item).focus();
    }

    function closeAll(except) {
      items.forEach(function (other) { if (other !== except) close(other); });
    }

    function open(item, how) {
      closeAll(item);
      clearTimeout(item._tcTimer);
      btnOf(item).setAttribute('aria-expanded', 'true');
      item._tcOpenedBy = how;
    }

    items.forEach(function (item) {
      var btn = btnOf(item);
      var panel = panelOf(item);
      if (!btn || !panel) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var how = e.detail === 0 ? 'key' : 'pointer';
        if (!isOpen(item)) { open(item, how); return; }
        if (item._tcOpenedBy === 'hover' && how === 'pointer') { item._tcOpenedBy = 'pointer'; return; }
        close(item);
      });

      if (item.hasAttribute('data-tc-disclosure-hover')) {
        item.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse' || !fineHover.matches) return;
          clearTimeout(item._tcTimer);
          if (isOpen(item)) return;
          item._tcTimer = setTimeout(function () { open(item, 'hover'); }, HOVER_OPEN_MS);
        });
        item.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse') return;
          clearTimeout(item._tcTimer);
          if (!isOpen(item) || item._tcOpenedBy === 'key') return;
          item._tcTimer = setTimeout(function () { close(item); }, 220);
        });
      }

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen(item)) {
          e.stopPropagation();
          close(item, true);
        } else if (e.key === 'ArrowDown' && e.target === btn) {
          e.preventDefault();
          if (!isOpen(item)) open(item, 'key');
          var first = panel.querySelector('a[href], button:not([disabled])');
          if (first) requestAnimationFrame(function () { first.focus(); });
        }
      });

      item.addEventListener('focusout', function (e) {
        var next = e.relatedTarget;
        if (!isOpen(item) || !next || item.contains(next)) return;
        close(item);
      });
    });

    document.addEventListener('click', function (e) {
      items.forEach(function (item) {
        if (isOpen(item) && !item.contains(e.target)) close(item);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    /* Search overlay or a drop below desktop width → nothing left hanging open */
    document.querySelectorAll('[data-search-toggle]').forEach(function (t) {
      t.addEventListener('click', function () { closeAll(); });
    });
    var desktopMq = window.matchMedia('(min-width: 1024px)');
    var onMq = function () { if (!desktopMq.matches) closeAll(); };
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', onMq);
    else if (desktopMq.addListener) desktopMq.addListener(onMq);
  })();

  /* Q3-01: every closed menu panel is inert, so nothing in it is a Tab stop
     or in the accessibility tree, whatever the CSS says. The mobile drawer
     follows its .is-open class (theme.js), each mobile tray and desktop
     panel its button's aria-expanded. Observers keep them in step with any
     script that opens or closes them, and run before the next frame, so a
     panel is live again before anything focuses into it. Browsers without
     `inert` still have the visibility rules. */
  (function () {
    'use strict';
    if (!window.MutationObserver) return;

    function setInert(el, on) {
      if (on) {
        if (!el.hasAttribute('inert')) el.setAttribute('inert', '');
      } else if (el.hasAttribute('inert')) {
        el.removeAttribute('inert');
      }
    }

    var drawer = document.querySelector('[data-mobile-nav]');
    if (drawer) {
      var syncDrawer = function () { setInert(drawer, !drawer.classList.contains('is-open')); };
      syncDrawer();
      new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    function follow(btn, panel) {
      if (!btn || !panel) return;
      var sync = function () { setInert(panel, btn.getAttribute('aria-expanded') !== 'true'); };
      sync();
      new MutationObserver(sync).observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    if (drawer) {
      Array.prototype.forEach.call(drawer.querySelectorAll('.tc-mobile-nav__toggle'), function (btn) {
        follow(btn, btn.nextElementSibling);
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-tc-disclosure]'), function (item) {
      follow(item.querySelector('[data-tc-disclosure-trigger]'), item.querySelector('[data-tc-disclosure-panel]'));
    });
  })();
